import './style.scss';
import './pagination.scss';
import React from 'react';
import { isServer } from '@sitecore-jss/sitecore-jss';
import { Image, RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react.js';
import { Pagination, Navigation } from 'swiper';
const CardItemsCarousel = (props) => {
  const { language, items, swiperRef, setPrevDisabled, setNextDisabled } = props;

  const pagination = {
    clickable: true,
    renderBullet: function (index, className) {
      return '<span class="custom-pagination-cardlisting ' + className + '"></span>';
    },
  };
  const onSwap = (pagesAmount, isFirst, isLast) => {
    setPrevDisabled(isFirst);
    setNextDisabled(isLast);
  };

  const handleSwap = (swiper) => {
    if (!onSwap) return;
    if (swiper?.pagination?.bullets?.length) {
      onSwap(swiper.pagination.bullets.length, swiper.isBeginning, swiper.isEnd);
    } else {
      onSwap(1, true, true);
    }
  };

  return (
    !isServer() && (
      <Swiper
        modules={[Pagination, Navigation]}
        pagination={pagination}
        dir={language === 'en' ? 'ltr' : 'rtl'}
        spaceBetween={32}
        slidesPerView={4}
        slidesPerGroup={4}
        onSlideChange={handleSwap}
        onPaginationRender={handleSwap}
        ref={swiperRef}
        breakpoints={{
          375: {
            slidesPerView: 'auto',
            freeMode: true,
            spaceBetween: 16,
            slidesPerGroup: 1,
          },
          768: {
            slidesPerView: 4,
            spaceBetween: 16,
            slidesPerGroup: 4,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 32,
            slidesPerGroup: 4,
          },
        }}
      >
        {items?.map((item, index) => {
          const _text = item?.fields?.text;
          const _heading = item?.fields?.heading;
          const _image = item?.fields?.image;

          const shouldRenderImage = !!_image?.value?.src;
          const shouldRenderTitle = !!_heading?.value && _heading !== '';
          const shouldRenderDescription = !!_text?.value && _text !== '';

          return (
            <SwiperSlide className="card-item" key={index}>
              <div className="auto">
                {shouldRenderImage && (
                  <div className="card-item-image">
                    <Image field={_image} />
                  </div>
                )}

                {shouldRenderTitle && (
                  <div className="card-item-title">
                    <Text field={_heading} />
                  </div>
                )}
                {shouldRenderDescription && (
                  <RichText className="card-item-description" field={_text} />
                )}
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    )
  );
};

export default CardItemsCarousel;
